import { PRICING_STATUS_LABELS } from '../../utils/helpers/aiSpendFormat';

const STYLES = {
  priced: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300',
  estimated: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  upper_bound: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  unknown_model: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
  unknown_quantity: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
  not_billable: 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300',
};

/**
 * How a cost was arrived at, shown next to the cost itself.
 *
 * Rides alongside the number rather than sitting in a tooltip or a footnote,
 * because a page that mixes exact figures with estimates and renders them
 * identically is the fastest way for a spend report to lose its credibility.
 */
export default function PricingStatusBadge({ status }) {
  if (!status || status === 'priced') return null;
  return (
    <span
      className={`ml-1.5 inline-flex rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase ${
        STYLES[status] || STYLES.not_billable
      }`}
    >
      {PRICING_STATUS_LABELS[status] || status}
    </span>
  );
}
